export class SuppliersFakeDb {
  public static suppliers = [
    {
      id: "345456l",
      uuid: "345456l",
      detail: {
        primaryindustry: "Security",
        abn: "909090888888",
        acn: "2378273982798789",
        name: "Ketty Marvel",
        tradingname: "Super Security",
        entitytype: "Sole Trader",
        phone_number: "92352424",
        email: "ketty@gmail.com",
      },
      documents: [],
      accreditation: [],
      members: [],
      venues: [],
    },
    {
      id: "98746563f",
      uuid: "98746563f",
      detail: {
        primaryindustry: "Security",
        abn: "345678987",
        acn: "3454566663322",
        name: "Jack Allon",
        tradingname: "Super Security",
        entitytype: "Sole Trader",
        phone_number: "0864321",
        email: "jack@gmail.com",
      },
      documents: [],
      accreditation: [],
      members: [],
      venues: [],
    },
  ];
}
